module.exports = __webpack_public_path__ + "img/antigua-and-barbuda.e8f8a0b1.svg";